import { useTranslation } from 'next-i18next/pages';
import { MouseEventHandler, useCallback } from 'react';
import { createPortal } from 'react-dom';

import { ReactComponent as Times } from '@pflegia/ui/icons/times.svg';

export interface YouTubePortalProps {
  autoPlay?: boolean;
  onDismiss: VoidFunction;
  videoId: string;
}

const YouTubePortal: React.FC<YouTubePortalProps> = ({ autoPlay = false, onDismiss, videoId }) => {
  const { t } = useTranslation('common');
  const handleDismiss = useCallback<MouseEventHandler<HTMLElement>>(
    event => {
      event.stopPropagation();
      onDismiss();
    },
    [onDismiss],
  );
  const urlParams = new URLSearchParams();
  if (autoPlay) urlParams.set('autoplay', '1');

  return createPortal(
    <div className='z-modal fixed top-0 right-0 bottom-0 left-0 grid place-items-center bg-gray-900/50' onClick={handleDismiss}>
      <button className='absolute top-0 right-0 cursor-pointer p-4 text-white' onClick={handleDismiss}>
        <Times title={t('close')} />
      </button>
      <iframe
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
        className='aspect-video max-h-[90vh] w-[90vw] shadow-md'
        frameBorder='0'
        onClick={event => event.stopPropagation()}
        src={`https://www.youtube.com/embed/${videoId}?${urlParams.toString()}`}
        title='YouTube video player'
      />
    </div>,
    document.body,
  );
};

export default YouTubePortal;
